import { render, staticRenderFns } from "./SampleBatchDetails.vue?vue&type=template&id=7aba7b00&scoped=true"
import script from "./SampleBatchDetails.vue?vue&type=script&lang=ts"
export * from "./SampleBatchDetails.vue?vue&type=script&lang=ts"
import style0 from "./SampleBatchDetails.vue?vue&type=style&index=0&id=7aba7b00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aba7b00",
  null
  
)

export default component.exports